<div class="fileupload focus-inwards-dark" data-test-id="fileupload" tabindex="0" (keyup.enter)="openElement()" (keyup.space)="openElement()">
	<input (change)="onFileChanged($event)" [attr.id]="myId" [accept]="accept" style="display: none;" type="file" #fileInput/>
	@if (!contentChildButton()) {
		<br/>
		<label [attr.for]="myId">
			<a color="primary" mat-flat-button class="focus-inwards-dark">
				<span>{{ defaultLabel }}</span>
			</a>
		</label>

	} @else {
		<label [attr.for]="myId" data-test-id="fileupload-content-children">
			<ng-content/>
		</label>
	}
</div>
